module.exports = function (form) {
    return function (values, $formContainer, followUpUrl) {
        var wistiaChannelId = Wistia.channel().hashedId();
        var wistiaListId = Wistia.channel().getListId();
        var emailAddress = values['Email'];
        var firstName = values['FirstName'];
        var lastName = values['LastName'];

        var submitData = {
            'channel_id': wistiaChannelId,
            'list_id': wistiaListId,
            'email_address': emailAddress
        };

        if (firstName && firstName.length) {
            submitData['first_name'] = firstName;
        }

        if (lastName && lastName.length) {
            submitData['last_name'] = lastName;
        }

        $.post('https://app.wistia.com/subscribe', submitData);
    };
};